var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23361 2.85475C9.63876 2.85475 10.5866 3.45359 11.1271 3.95399L13.2389 1.91957C11.9419 0.730095 10.254 0 8.23361 0C5.30691 0 2.77931 1.65707 1.54877 4.06884L3.96828 5.92279C4.57524 4.14267 6.25477 2.85475 8.23361 2.85475Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4167 7.54652C15.4167 6.93947 15.3668 6.49649 15.2587 6.03711H8.23297V8.77701H12.357C12.2738 9.45789 11.8248 10.4833 10.8271 11.1724L13.1884 12.9771C14.6019 11.6892 15.4167 9.79422 15.4167 7.54652Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97602 8.84366C3.81805 8.38428 3.72659 7.89208 3.72659 7.38347C3.72659 6.87487 3.81805 6.38267 3.96771 5.92328L1.54819 4.06934C1.04101 5.07014 0.75 6.19399 0.75 7.38347C0.75 8.57295 1.04101 9.69681 1.54819 10.6976L3.97602 8.84366Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23329 14.7656C10.2537 14.7656 11.9499 14.1093 13.1887 12.9772L10.8274 11.1725C10.1955 11.6073 9.34743 11.9108 8.23329 11.9108C6.25444 11.9108 4.57492 10.6229 3.97627 8.84277L1.55676 10.6967C2.7873 13.1085 5.30659 14.7656 8.23329 14.7656Z",
    fill: "#34A853"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Google.5965a52c.svg";
export { ForwardRef as ReactComponent };